export const unauthorized = {
  redirect: {
    url: import.meta.env.VITE_UNAUTHORIZED_REDIRECT_URL || '',
  },
}
